<template>
  <div class="grid-wrapper">
    <div class="grid-inner" v-if="!impactLayout">
      <GridItem
        :prevId="prevId(index)"
        :nextId="nextId(index)"
        :item="item"
        v-for="(item, index) in items"
        :key="item.id"
      />
    </div>

    <div
      class="grid-inner impact-layout"
      v-if="impactLayout"
      :class="{ 'odd-count': items.length % 2 }"
    >
      <ImpactGridItem
        :prevId="prevId(index)"
        :nextId="nextId(index)"
        :item="item"
        v-for="(item, index) in items"
        :key="item.id"
      />
    </div>
  </div>
</template>

<script>
import GridItem from "./Grid/GridItem";
import ImpactGridItem from "./Grid/ImpactGridItem";

export default {
  name: "Grid",
  components: { GridItem, ImpactGridItem },
  props: {
    items: Array,
    impactLayout: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    prevId(index) {
      if (index == 0) {
        return null;
      } else {
        return this.items[index - 1].id;
      }
    },
    nextId(index) {
      if (index == this.items.length - 1) {
        return null;
      } else {
        return this.items[index + 1].id;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid-wrapper {
  width: 100%;
}
.grid-inner {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.grid-inner.impact-layout {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .grid-item {
    flex-basis: calc(50% - 16px);
  }
  &.odd-count .grid-item:first-child {
    flex-basis: 100%;
  }
}

@media screen and (max-width: 960px) {
  .grid-inner:not(.impact-layout) {
    grid-template-columns: 1fr 1fr;
  }

  .grid-inner.impact-layout {
    .grid-item {
      flex-basis: 100%;
      &__image::before {
        padding-bottom: 55.6%;
      }
    }
    .grid-item__image::before {
      padding-bottom: 55.6%;
    }
  }
}

@media screen and (max-width: 600px) {
  .grid-inner:not(.impact-layout) {
    grid-template-columns: 1fr;
  }
}
</style>
